import * as React from 'react'

const SvgStepBottomIcon = (props) => (
  <svg
    width="15"
    height="9"
    viewBox="0 0 15 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.3723 8.09772C0.481394 8.09772 0.0352269 7.02058 0.665191 6.39061L6.73625 0.319537C7.12678 -0.0709878 7.75994 -0.0709876 8.15047 0.319537L14.2215 6.39061C14.8515 7.02058 14.4053 8.09772 13.5144 8.09772H1.3723Z"
      fill="white"
    />
  </svg>
)

export default SvgStepBottomIcon
